module.exports = __webpack_public_path__ + "img/dialpad.f9357d4b.svg";